import { render } from "./DocumentListView.vue?vue&type=template&id=b9016a14"
import script from "./DocumentListView.vue?vue&type=script&lang=js"
export * from "./DocumentListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__